export default __webpack_public_path__ + "static/media/circleImg.a59ae8eb.png";